// paymentSummeryActions.js



// Action types
export const SET_PLAN = 'SET_PLAN';
export const SET_ADDONS = 'SET_ADDONS';
export const SET_TOTAL_PRICE = 'SET_TOTAL_PRICE';
export const SET_FULL_PRICE = 'SET_FULL_PRICE';
export const SET_MONTHLY_PRICE = 'SET_MONTHLY_PRICE';
export const SET_MONTHLY_REPAYMENT = 'SET_MONTHLY_REPAYMENT';
export const SET_DEPOSIT_PRICE = 'SET_DEPOSIT_PRICE';
export const SET_INSURER_DEPOSIT_PRICE = 'SET_INSURER_DEPOSIT_PRICE';
export const SET_INSURER_MONTHLY_REPAYMENT = 'SET_INSURER_MONTHLY_REPAYMENT';
export const SET_INSURER_FULL_PRICE = 'SET_INSURER_FULL_PRICE';
export const SET_INSURER_PLAN = 'SET_INSURER_PLAN';
export const SET_PRODUCT_BOTH_PRICES = 'SET_PRODUCT_BOTH_PRICES';
export const SET_TOTAL_CHARGE_CREDIT = 'SET_TOTAL_CHARGE_CREDIT';
export const SET_BROKER_FEE = 'SET_BROKER_FEE';
export const SET_SELECT_INSURER_TYPE = 'SET_SELECT_INSURER_TYPE';
export const SET_AI_DEPOSIT_PRICE = 'SET_AI_DEPOSIT_PRICE';
export const SET_AI_MONTHLY_REPAYMENT = 'SET_AI_MONTHLY_REPAYMENT';
export const SET_AI_FULL_PRICE = 'SET_AI_FULL_PRICE';
export const SET_AI_MONTHLY_FULL = 'SET_AI_MONTHLY_FULL';
export const SET_USER_EMAIL = 'SET_USER_EMAIL';
export const SET_SELECT_AI_INSURER_TYPE = 'SET_SELECT_AI_INSURER_TYPE';
export const SET_AI_TOTAL_CHARGE_CREDIT = 'SET_AI_TOTAL_CHARGE_CREDIT';







// Action to set selected plan
export const setPlans = (plan) => ({
    type: SET_PLAN,
    payload: plan
});

// Action to set selected add-ons
export const setAddons = (addons) => ({
    type: SET_ADDONS,
    payload: addons
});

// Action to set total price
export const setTotalPrice = (totalPrice) => ({
    type: SET_TOTAL_PRICE,
    payload: totalPrice
});

// Action to set Full price
export const setFullPrice = (totalPrice) => ({
    type: SET_FULL_PRICE,
    payload: totalPrice
});

// Action to set Monthly price
export const setMonthlyPrice = (totalPrice) => ({
    type: SET_MONTHLY_PRICE,
    payload: totalPrice
});

// Action to set Monthly price
export const setMonthlyRepayment = (repayment) => ({
    type: SET_MONTHLY_REPAYMENT,
    payload: repayment
});

// Action to set Deposit price
export const setDepositPrice = (depositPrice) => ({
    type: SET_DEPOSIT_PRICE,
    payload: depositPrice
});

// Action to set Total Charge Credit
export const setTotaChargeCredit = (totaChargeCredit) => ({
    type: SET_TOTAL_CHARGE_CREDIT,
    payload: totaChargeCredit
});

// Action to set Broker Fee
export const setBrokerFee = (brokerFee) => ({
    type: SET_BROKER_FEE,
    payload: brokerFee
});

// Action to set Broker Fee
export const setSelectInsurerTypes = (selectInsurerType) => ({
    type: SET_SELECT_INSURER_TYPE,
    payload: selectInsurerType
});

// Action to set AI Broker Fee
export const setAIDepositPrice = (aiDepositPrice) => ({
    type: SET_AI_DEPOSIT_PRICE,
    payload: aiDepositPrice
});

// Action to set AI Monthly price
export const setAIMonthlyRepayment = (aiMonthlyRepayment) => ({
    type: SET_AI_MONTHLY_REPAYMENT,
    payload: aiMonthlyRepayment
});

// Action to set AI Full price
export const setAIFullPrice = (aitotalPrice) => ({
    type: SET_AI_FULL_PRICE,
    payload: aitotalPrice
});

// Action to set AI Monthly Full price
export const setAIMonthlyFull = (aiMonthlyFull) => ({
    type: SET_AI_MONTHLY_FULL,
    payload: aiMonthlyFull
});

// Action to set User Email
export const setUserEmail = (userEmail) => ({
    type: SET_USER_EMAIL,
    payload: userEmail
});

// Action to set Broker Fee
export const setSelectAiInsurerTypes = (selectAiInsurerType) => ({
    type: SET_SELECT_AI_INSURER_TYPE,
    payload: selectAiInsurerType
});

// Action to set Total Charge Credit
export const setAiTotaChargeCredit = (aitotaChargeCredit) => ({
    type: SET_AI_TOTAL_CHARGE_CREDIT,
    payload: aitotaChargeCredit
});